import clsx from 'clsx';
import { Link } from '@/npm/next.js';
import React, { FunctionComponent } from 'react';
import styles from './PurchaseNav.module.scss';
import { PurchaseNavProps } from './PurchaseNav.type.js';

export const PurchaseNav: FunctionComponent<PurchaseNavProps> = ({
  tabs,
  announceId,
  activeTab,
}) => {
  return (
    <div className={styles.nav}>
      {Object.keys(tabs).map((item) => (
        <Link
          key={`${announceId}/${item}`}
          href={`/purchases/${announceId}/${item}`}
          className={clsx(styles.navItem, activeTab === item && styles.active)}
        >
          {tabs[item].title}{' '}
        </Link>
      ))}
    </div>
  );
};
